<template>
  <base-container class="cascade-picker-page">
    <cascade-picker-basic />
    <view class="cascade-picker-divider-wrapper">
      <cube-divider />
    </view>
    <cube-async-cascade-picker />
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus" scoped>
.cascade-picker-divider-wrapper
  margin 10px 0
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "cascade-picker-basic": "./cascade-picker-basic",
      "cube-async-cascade-picker": "./async-picker"
    }
  }
</script>
